import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";

const LOG_TAG = "SERVICE:CONTACT";

class ContactService {
    constructor(serverInstance) {
        LogService.debug(LOG_TAG, "constructor", "instanciated with:", serverInstance);
        this.serverInstance = serverInstance;
    }

    reset() {
        this.serverInstance = null;
    }

    getAvatarUrl(contactId) {
        return this.serverInstance.getServerUrl() + "/api/avatar/" + contactId + "?size=256";
    }
    
    getContactDataById(contactId, format = "small") {
        let queryParameters = "?format=" + format;

        return this.serverInstance.get("/api/rainbow/enduser/v1.0/users/" + contactId + queryParameters)
            .then(response => {
                const contact = response.data;
                if (contact?.lastAvatarUpdateDate) {
                    contact.avatar = this.getAvatarUrl(contact.id)
                }
                return Promise.resolve(contact);
            })
            .catch(error => {
                LogService.error(LOG_TAG, "getContactDataById", "error", error);
                return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
            });
    }

    getContactDataByJid(jid, format = "small") {
        LogService.trace(LOG_TAG, "getContactDataByJid", "enter");
        let queryParameters = "?format=" + format;

        return this.serverInstance.get("/api/rainbow/enduser/v1.0/users/jids/" + jid + queryParameters)
            .then(response => {
                LogService.info(LOG_TAG, "getContactDataByJid");
                const contact = response.data;
                if (contact?.lastAvatarUpdateDate) {
                    contact.avatar = this.getAvatarUrl(contact.id)
                }
                return Promise.resolve(contact);
            })
            .catch(error => {
                LogService.error(LOG_TAG, "getContactDataByJid", "error", error);
                return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
            });
    }

    getContactDataByJidList(jidList, format = "small") {
        LogService.trace(LOG_TAG, "getContactDataByJidList", "enter");
        let queryParameters = "?format=" + format;
        let body = {
            jid_im: jidList
        };

        return this.serverInstance.post("/api/rainbow/enduser/v1.0/users/jids" + queryParameters, JSON.stringify(body))
            .then(contactList => {
                LogService.info(LOG_TAG, "getContactDataByJidList", "success");

                const contactListWithAvatar = contactList.data.map((contact) => {
                    if (contact?.lastAvatarUpdateDate) {
                        contact.avatar = this.getAvatarUrl(contact.id)
                    }
                    return contact;
                });
                return Promise.resolve(contactListWithAvatar);
            })
            .catch(error => {
                LogService.error(LOG_TAG, "getContactDataByJidList", "error", error);
                return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
            });
    }
};

export default ContactService;